<div [formGroup]="form">
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">calculate</mat-icon>
        <span>Base de Cálculo IBS/CBS</span>
        <div class="section-title-actions ms-auto">
            <button mat-button type="button" class="btn-section" [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0" (click)="abrirEditorFormulas()">
                <mat-icon class="material-symbols-outlined">settings</mat-icon>
                Personalizar fórmulas
            </button>
        </div>
    </div>

    <app-alert-card type="info" title="Base de cálculo IBS/CBS" icon="info">
        A base de cálculo do IBS e da CBS é apurada uma única vez por item e compartilhada pelas seções de IBS UF, IBS Município e CBS abaixo. Use "Personalizar fórmulas" para ajustar a composição (produto, frete, seguro, desconto e demais parcelas) quando o padrão não atender.
    </app-alert-card>

    <app-ativacao-section-card
        [control]="reducaoBaseCalculoControl"
        titulo="Redução da base de cálculo"
        [exibirTituloNoAlerta]="false"
        descricaoAtivo="Redução ativa. O percentual abaixo reduz a base de cálculo do IBS e da CBS."
        descricaoInativo="Redução inativa. A base de cálculo cheia será usada no cálculo."
        emptyStateTitulo="Redução da base de cálculo desativada"
        emptyStateDescricao="Ative a redução acima para informar o percentual de redução da base de cálculo do IBS e da CBS.">
    </app-ativacao-section-card>

    @if (reducaoBaseCalculoControl.value) {
    <div class="sub-section-container">
        <div class="sub-section-title">
            <mat-icon class="material-symbols-outlined">trending_down</mat-icon>
            <span>Redução da base de cálculo</span>
        </div>
        <div class="row g-3">
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Redução da base (%)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualReducaoBaseCalculo">
                    <mat-error>{{ form.get('percentualReducaoBaseCalculo')?.hasError('min') ? 'O percentual de redução da base de cálculo do IBS/CBS deve estar entre 0 e 100.' : 'Informe o percentual de redução da base de cálculo do IBS/CBS.' }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    }
</div>
</div>
